/* APLB — carrousel de photos dans une carte produit.
   Defilement natif au doigt (scroll-snap) ; les points suivent la photo
   affichee et permettent d'y aller au clic. */
(function () {
  if (customElements.get('aplb-card-slider')) return;

  class AplbCardSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.aplb-card-slider__track');
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.aplb-card-slider__dot'));
      if (!this.track || this.dots.length < 2) return;

      this.slides = Array.prototype.slice.call(this.track.querySelectorAll('.aplb-card-slider__slide'));
      this.index = 0;
      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      var self = this;
      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function (evt) {
          evt.preventDefault();
          evt.stopPropagation();
          var slide = self.slides[parseInt(dot.dataset.index, 10) || 0];
          if (slide) self.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.raf) return;
      var self = this;
      this.raf = window.requestAnimationFrame(function () {
        self.raf = null;
        var width = self.track.clientWidth || 1;
        var index = Math.round(self.track.scrollLeft / width);
        if (index === self.index) return;
        self.index = index;
        self.dots.forEach(function (dot, i) {
          dot.classList.toggle('is-on', i === index);
        });
      });
    }
  }

  customElements.define('aplb-card-slider', AplbCardSlider);
})();
